import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { PHONE_PLACEHOLDER } from 'utils/constants/defaultValues'
import { Error } from 'components/error/Error'
import { InputNumberFormat } from 'components/inputNumberFormat/InputNumberFormat'

export const PhoneInput = ({
  allowEmptyFormatting = true,
  error,
  format = '(###) ### ####',
  handleIsAllowed,
  isDisabled,
  mask = '_',
  onChange,
  placeholder = PHONE_PLACEHOLDER,
  size,
  showErrorText = true,
  value,
}) => (
  <Fragment>
    <InputNumberFormat
      allowEmptyFormatting={allowEmptyFormatting}
      error={error}
      format={format}
      handleIsAllowed={handleIsAllowed}
      isDisabled={isDisabled}
      mask={mask}
      onChange={({ value }) => onChange(value)}
      placeholder={placeholder}
      size={size}
      value={value}
    />

    {error && showErrorText && <Error>{error}</Error>}
  </Fragment>
)

PhoneInput.propTypes = {
  allowEmptyFormatting: PropTypes.bool,
  error: PropTypes.string,
  format: PropTypes.string,
  handleIsAllowed: PropTypes.func,
  isDisabled: PropTypes.bool,
  mask: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['regular', 'small']),
  showErrorText: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
